import { NavLink } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const Navigation = () => {
  const { user } = useAuth()

  const navItems = [
    { path: '/', label: 'Home', end: true },
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/projects', label: 'Projects' },
    { path: '/analyses', label: 'Analyses', end: true },
    { path: '/invitations', label: 'Invitations', adminOnly: true },
  ]

  // Filter nav items based on user permissions
  const visibleNavItems = navItems.filter(
    (item) => !item.adminOnly || user?.is_staff || user?.is_superuser
  )

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8">
          {visibleNavItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  isActive
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  )
}

export default Navigation
